module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "root",
    staticClass: ["dof-gear"],
    on: {
      "touchmove": _vm.onTouchMove
    }
  }, [_vm._l((_vm.ranges), function(v, i) {
    return [_c('div', {
      key: i,
      ref: "bar",
      refInFor: true,
      staticClass: ["dof-gear-item"],
      on: {
        "click": function () { return _vm.onClick(v); }
      }
    }, [(!_vm.readonly) ? _c('div', {
      staticClass: ["dof-gear-item-anchor"]
    }, [_c('div', {
      staticClass: ["dof-gear-item-anchor-angle"],
      style: _vm.getAngleStyle(v)
    })]) : _vm._e(), _c('div', {
      staticClass: ["dof-gear-item-track"],
      style: _vm.trackStyle
    }, [_c('div', {
      staticClass: ["dof-gear-item-bar"],
      style: _vm.getBarStyle(v)
    })]), (v.gear) ? _c('text', {
      staticClass: ["dof-gear-item-gear"],
      style: _vm.gearStyle
    }, [_vm._v(_vm._s(v.gear))]) : _vm._e()]), (!_vm.isLast(i)) ? _c('div', {
      key: ("gap-" + i),
      staticClass: ["dof-gear-gap"]
    }) : _vm._e()]
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-c58a7930!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-gear/index.vue
// module id = 652
// module chunks = 0 1